var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 211.878,
    height: 360.931,
    viewBox: "0 0 211.878 360.931",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.431,
    y1: 0.512,
    x2: 1.231,
    y2: 0.493,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a977f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#a776f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542,
    stopColor: "#a072f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645,
    stopColor: "#946cf3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#8364f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.798,
    stopColor: "#6d59ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#534bea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899,
    stopColor: "#3e41e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.233,
    y1: 0.654,
    x2: 1.324,
    y2: -0.319,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7c4dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466,
    stopColor: "#7a4cfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634,
    stopColor: "#734bfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.754,
    stopColor: "#6749f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#5645f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    stopColor: "#4141e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942,
    stopColor: "#3e41e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.101,
    y1: 1.062,
    x2: 1.532,
    y2: -0.474,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#08f6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347,
    stopColor: "#08f4fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#08edf9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#0ae1f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634,
    stopColor: "#0bd0f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#0dbaf3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#109fef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#137eeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.845,
    stopColor: "#1759e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#1b30e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.907,
    stopColor: "#1e17de"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1.119,
    y1: 0.878,
    x2: -0.668,
    y2: -0.284,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#08f6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#08f3fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392,
    stopColor: "#09ebf9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#0addf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#0cc9f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.701,
    stopColor: "#0eaff1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786,
    stopColor: "#1290ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    stopColor: "#156ae8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.939,
    stopColor: "#1940e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e17de"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.323,
    y1: -0.644,
    x2: 0.723,
    y2: 1.94,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#08f6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#08f4fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421,
    stopColor: "#08edf9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#0ae1f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565,
    stopColor: "#0bd0f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    stopColor: "#0dbaf3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#109fef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713,
    stopColor: "#137eeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.754,
    stopColor: "#1759e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#1b30e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#1e17de"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.398,
    y1: 0.209,
    x2: 0.628,
    y2: 0.866,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1.104,
    y1: 1.058,
    x2: -0.57,
    y2: -0.499,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -0.039,
    y1: 0.867,
    x2: 1.65,
    y2: -0.309,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.1,
    y1: 0.069,
    x2: 1.326,
    y2: 1.344,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.865,
    y1: 0.054,
    x2: -0.273,
    y2: 1.306,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1.236,
    y1: 0.032,
    x2: 0.143,
    y2: 1.031,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00e5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    stopColor: "#01e3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#05dcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#0dd0f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    stopColor: "#18bff5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953,
    stopColor: "#27a9f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#329aec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -0.28,
    y1: -0.033,
    x2: 0.835,
    y2: 1.058,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -0.842,
    y1: -0.318,
    x2: 0.93,
    y2: 1.032,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 1.152,
    y1: 0.111,
    x2: 0.184,
    y2: 1.031,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 0.5,
    y1: -0.352,
    x2: 0.5,
    y2: 1.504,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 0.5,
    y1: 1.59,
    x2: 0.5,
    y2: -0.776,
    xlinkHref: "#linear-gradient-11"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_12747",
    "data-name": "Groupe 12747",
    transform: "translate(1219 9852)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_12744",
    "data-name": "Groupe 12744",
    transform: "translate(-1181.706 -9566.298)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1176",
    "data-name": "Trac\\xE9 1176",
    d: "M2419.415,691.292v26.215l-67.365-61.667,13.555-13.562h.268Z",
    transform: "translate(-2352.05 -642.279)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1177",
    "data-name": "Trac\\xE9 1177",
    d: "M2473.059,691.292v26.215l67.367-61.667-13.557-13.562h-.265Z",
    transform: "translate(-2405.691 -642.279)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_12745",
    "data-name": "Groupe 12745",
    transform: "translate(-1219 -9852)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1178",
    "data-name": "Trac\\xE9 1178",
    d: "M2477.735,129.316l-12.334,26.17-12.231-26.414Z",
    transform: "translate(-2359.582 -129.073)",
    fill: "#00e5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1179",
    "data-name": "Trac\\xE9 1179",
    d: "M2390.878,155.49l-77.938,174.161-.019.039-.234.5-16.215,35.362v.005l-2.9-2.422h-.007l-3.08-2.566-5.426-22.335,93.59-209.155Z",
    transform: "translate(-2285.06 -129.076)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1180",
    "data-name": "Trac\\xE9 1180",
    d: "M2361.5,544.981l-11.647,17.575-44.291-36.865,16.217-35.363.006.006-1.23,2.75a18.762,18.762,0,0,0,5.44,22.346Z",
    transform: "translate(-2294.147 -289.214)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1181",
    "data-name": "Trac\\xE9 1181",
    d: "M2484.128,630.874a.756.756,0,0,1-.073.034c-.176.078-.349.15-.527.211-.084.033-.172.067-.262.1-.178.073-.361.134-.54.2q-.734.25-1.474.451c-.141.038-.282.072-.419.105-.217.056-.44.106-.663.151-.028.005-.05.01-.07.016-.257.056-.519.106-.78.15-.579.1-1.165.178-1.749.228-.16.022-.324.033-.484.044-.229.017-.456.034-.686.039-.312.017-.616.022-.93.022h-.173A23.4,23.4,0,0,0,2484.128,630.874Z",
    transform: "translate(-2369.39 -351.516)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1182",
    "data-name": "Trac\\xE9 1182",
    d: "M2491.954,630.264l-.1.051c-.208.1-.42.194-.632.278C2491.462,630.487,2491.708,630.375,2491.954,630.264Z",
    transform: "translate(-2376.448 -351.246)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1183",
    "data-name": "Trac\\xE9 1183",
    d: "M2475.14,155.68l78.18,174.161.017.039.234.5,16.216,35.362v.005l2.9-2.422h.006l3.079-2.566,5.427-22.335L2487.477,129.51Z",
    transform: "translate(-2369.32 -129.266)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1184",
    "data-name": "Trac\\xE9 1184",
    d: "M2544.67,544.981l11.646,17.575,44.293-36.865-16.218-35.363,0,.006,1.229,2.75a18.79,18.79,0,0,1-5.438,22.346Z",
    transform: "translate(-2400.143 -289.214)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1185",
    "data-name": "Trac\\xE9 1185",
    d: "M2485.588,606.079l-4.386,3.652-19.079,15.877-2.956,2.461-5.741,4.777-.1.083H2417.38l-.641-.535-30.779-25.614-.842-.7,11.646-17.575.706.59,19.688,16.384,4.048,3.368a20.735,20.735,0,0,0,2.692,1.9c.218.134.435.256.651.373.44.245.886.473,1.337.679.211.1.423.195.635.278.032.011.066.028.1.044.18.078.353.15.53.211.085.034.173.067.261.1.18.072.363.134.541.2.489.167.979.317,1.475.45.141.039.278.072.419.106.217.056.44.106.662.15l.071.016q.338.076.681.134c.061.011.123.017.184.028.523.084,1.052.156,1.579.206a.424.424,0,0,0,.084.012c.161.022.324.033.484.044.23.017.458.033.684.039.313.017.622.022.934.022h.281c.312,0,.62-.005.932-.022.228-.005.456-.022.684-.039.16-.012.322-.022.484-.044.584-.051,1.17-.128,1.747-.228.264-.045.525-.1.782-.151l.069-.016c.225-.044.447-.095.664-.15.14-.033.277-.067.417-.106q.743-.2,1.477-.45c.178-.062.361-.123.539-.2.09-.034.179-.067.26-.1.179-.062.354-.134.531-.211a.658.658,0,0,0,.071-.034c.013-.005.023-.005.034-.011.211-.083.424-.178.634-.278l.1-.05c.244-.112.489-.229.729-.356.169-.089.34-.178.508-.273.217-.117.434-.24.649-.373.028-.017.052-.033.078-.05.157-.089.317-.189.469-.289.168-.1.328-.206.482-.317a20.725,20.725,0,0,0,1.667-1.247l17.63-14.675,6.809-5.667Z",
    transform: "translate(-2329.414 -332.734)",
    fill: "#08f6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1186",
    "data-name": "Trac\\xE9 1186",
    d: "M2479.018,652.893,2461.057,633.8l-17.987,19.089Z",
    transform: "translate(-2355.103 -352.815)",
    fill: "#00e5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1187",
    "data-name": "Trac\\xE9 1187",
    d: "M2435.925,614.31l-17.875,18.973-.64-.417-30.782-25.614,11.515-17.687,19.685,16.384,4.048,3.368a20.783,20.783,0,0,0,2.692,1.9c.218.134.438.256.652.373.439.245.887.473,1.338.679.21.1.421.195.633.278.032.011.066.028.107.045.179.078.349.15.527.211l.264.1c.178.072.361.133.537.194q.735.25,1.477.452c.139.038.278.072.417.105.218.056.44.105.662.15l.074.016c.222.05.45.095.68.134.059.011.121.017.182.028.523.083,1.053.156,1.583.206a.421.421,0,0,0,.082.011c.162.022.322.033.482.044.23.017.458.033.688.039.312.017.618.023.93.023Z",
    transform: "translate(-2330.084 -333.204)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1188",
    "data-name": "Trac\\xE9 1188",
    d: "M2521.125,614.244l-19.079,15.878-2.957,2.46-5.74,4.776-.1-.033-18.071-18.973h.239c.312,0,.618-.005.93-.023.229,0,.457-.022.686-.039.16-.011.322-.022.484-.044.584-.05,1.17-.129,1.747-.229.262-.044.525-.095.78-.15.022-.005.044-.011.072-.017.223-.045.445-.095.663-.15.137-.033.277-.067.417-.106q.741-.2,1.476-.451c.177-.061.36-.123.538-.2.091-.034.18-.067.264-.1.179-.061.351-.134.527-.212a.66.66,0,0,0,.073-.033c.012-.006.022-.006.034-.011.212-.083.424-.178.633-.278l.1-.05c.245-.111.489-.228.729-.356.167-.089.339-.178.507-.273.216-.117.435-.24.65-.373.028-.017.05-.033.076-.05.158-.089.319-.189.471-.289q.25-.151.481-.317a20.775,20.775,0,0,0,1.666-1.247l17.631-14.675Z",
    transform: "translate(-2369.337 -337.247)",
    fill: "url(#linear-gradient-10)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_12746",
    "data-name": "Groupe 12746",
    transform: "translate(-1165.889 -9710.949)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1189",
    "data-name": "Trac\\xE9 1189",
    d: "M2426.052,499.04l-12.109-71.708-33.479,29.334Z",
    transform: "translate(-2380.463 -402.344)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1190",
    "data-name": "Trac\\xE9 1190",
    d: "M2426.052,522.4l-32.624-1.174-12.965-41.2Z",
    transform: "translate(-2380.463 -425.702)",
    fill: "#00e5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1191",
    "data-name": "Trac\\xE9 1191",
    d: "M2413.942,407.435l-27.623-24.989-5.856,54.323Z",
    transform: "translate(-2380.463 -382.446)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1192",
    "data-name": "Trac\\xE9 1192",
    d: "M2488.5,499.04l12.108-71.708,33.479,29.334Z",
    transform: "translate(-2428.357 -402.344)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1193",
    "data-name": "Trac\\xE9 1193",
    d: "M2488.5,522.392l32.254,0,13.334-42.376Z",
    transform: "translate(-2428.357 -425.699)",
    fill: "#00e5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1194",
    "data-name": "Trac\\xE9 1194",
    d: "M2510.259,407.435l27.622-24.989,5.857,54.324Z",
    transform: "translate(-2437.999 -382.446)",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1195",
    "data-name": "Trac\\xE9 1195",
    d: "M2479.382,427.332l-12.11,71.7h-14.562l-12.106-71.7Z",
    transform: "translate(-2407.121 -402.343)",
    fill: "url(#linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1196",
    "data-name": "Trac\\xE9 1196",
    d: "M2403.749,554.03l41.41,22.36,38.029-21.186-32.254,0h-14.561Z",
    transform: "translate(-2390.786 -458.507)",
    fill: "url(#linear-gradient-16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1197",
    "data-name": "Trac\\xE9 1197",
    d: "M2462.351,556.133h14.562l-7.281,7.843Z",
    transform: "translate(-2416.763 -459.44)",
    fill: "#329aec"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e25e36ac52d85a6af8bce66c45bf98c1.svg";
export { ForwardRef as ReactComponent };